import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { SITE_CONTENT } from "../content";

const SocialIcon = ({ icon }) => {
  const icons = {
    facebook: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
      </svg>
    ),
    twitter: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13">
        <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
      </svg>
    ),
    "google-plus": (
      <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13">
        <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
      </svg>
    ),
    pinterest: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13">
        <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
      </svg>
    ),
    instagram: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <path
          fill="none"
          stroke="white"
          strokeWidth="2"
          d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"
        />
        <line
          x1="17.5"
          y1="6.5"
          x2="17.51"
          y2="6.5"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 0 0-2.122 2.136C0 8.186 0 12 0 12s0 3.814.501 5.814a3.016 3.016 0 0 0 2.122 2.136c1.872.55 9.377.55 9.377.55s7.505 0 9.377-.55a3.016 3.016 0 0 0 2.122-2.136C24 15.814 24 12 24 12s0-3.814-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  };
  return icons[icon] || null;
};

const Header = () => {
  const { global } = SITE_CONTENT;
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="rest-header">
      {/* === TOP INFO BAR === */}
      <div className="rest-topbar">
        <div className="rest-topbar-inner">
          <div className="rest-topbar-left">
            <span className="rest-topbar-item">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                width="13"
                height="13"
              >
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.63A2 2 0 012 .92h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.35-1.35a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
              </svg>
              {global.topBar.phone}
            </span>
            <span className="rest-topbar-divider">|</span>
            <span className="rest-topbar-item">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                width="13"
                height="13"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              {global.topBar.email}
            </span>
            <span className="rest-topbar-divider">|</span>
            <span className="rest-topbar-item rest-halal-badge" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <svg viewBox="0 0 100 100" width="16" height="16" fill="currentColor">
                <circle cx="50" cy="50" r="45" fill="none" stroke="currentColor" strokeWidth="5"/>
                <circle cx="50" cy="50" r="38" fill="none" stroke="currentColor" strokeWidth="2"/>
                <text x="50" y="55" fontSize="26" fontWeight="bold" textAnchor="middle" fill="currentColor">حلال</text>
                <text x="50" y="75" fontSize="12" fontWeight="bold" textAnchor="middle" fill="currentColor">HALAL</text>
              </svg>
              100% Halal Certified
            </span>
          </div>
          <div className="rest-topbar-right">
            {global.topBar.socials.map((s, i) => (
              <a
                key={i}
                href={s.href}
                className="rest-topbar-social"
                aria-label={s.icon}
              >
                <SocialIcon icon={s.icon} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* === LOGO + NAV ROW === */}
      <div className={`rest-navbar${scrolled ? " rest-navbar--scrolled" : ""}`}>
        <div className="rest-navbar-inner">
          {/* Logo */}
          <Link to="/" className="rest-nav-logo">
            <img src={global.logoImage} alt={global.logoText} />
          </Link>

          {/* Desktop Nav */}
          <nav className="rest-nav-links" aria-label="Main navigation">
            {global.navLinks.map((link, idx) => (
              <React.Fragment key={idx}>
                <a href={link.to} className="rest-nav-link">
                  {link.label}
                </a>
                {idx < global.navLinks.length - 1 && (
                  <span className="rest-nav-sep">|</span>
                )}
              </React.Fragment>
            ))}
          </nav>

          {/* Order Now */}
          <Link to="/order" className="rest-nav-order" aria-label="Order Now">
            Order Now 🛵
          </Link>

          {/* Mobile Hamburger */}
          <button
            className="rest-hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {/* Mobile Dropdown */}
        {menuOpen && (
          <div className="rest-mobile-menu">
            {global.navLinks.map((link, idx) => (
              <a
                key={idx}
                href={link.to}
                className="rest-mobile-link"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            {/* Order Now link on mobile */}
            <div className="rest-mobile-order-group">
              <Link
                to="/order"
                className="rest-mobile-order rest-mobile-order-swiggy"
                onClick={() => setMenuOpen(false)}
                style={{ width: "100%", textAlign: "center", display: "block" }}
              >
                Order Now 🛵
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
